import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function getUserWatchlist(tickers) {
  const data = await fetchAPI(
    `
    {
      getWatchlistMetrics(tickers: [${tickers && tickers.length > 0 && tickers.map(d => `"${d}"`)}]) {
        ticker
        tickername: name
        sector
        industry
        PCHG__7
        PCHG__30
        PCHG__180
        PCHG__365
        RETURNS__1095
        REV_TTM
        NETINC_TTM
        MKTCAP
        EBT
        REV_TTM__PCHG_1Y
        NETINC_TTM__PCHG_1Y
        REV_TTM__PCHG_3Y
        NETINC_TTM__PCHG_3Y
        SHR_OUTS__PCHG_1Y
        SHR_OUTS__PCHG_3Y
        PE
        PS
        PCF
        MKTEBT
        ROA
        ROE
        DIV_YIELD
        BUYBACK__PCHG_1Y
        DEBT_EQ
        EBT_MGN
        NETINC_MGN
        OPER_MGN
        DRAWDN_PROB30__5Y
        VOL__Y
        EBITDA_TTM
        FCF_TTM
        FCF_PS_TTM
        FCF_YIELD
        ASSETS
        LIABS
        SEQ
        RETEARN
        RETEARN__PCHG_1Y
        RETEARN__PCHG_3Y
        EV_EBITDA
        PFCF
        EBITDA_MGN
        CFINV
        CFINV_TTM
        CFOPER
        CFOPER_TTM
        CFFIN
        CFFIN_TTM
        CASHEQ
        CR
        ASSETS__PCHG_1Y
        ASS_SAL
        DEBT_LT
        DIV_PS_TTM
        DRAWDN
        EPS
        EPS_TTM
        INT_COV
        INT_CFOPER
        RETURNS__1825
        RISKLEVEL__5Y
        ITXR
        COSTREV
        IMP_ASSETS
        INVWD
        SHRCOMP_TTM
        EV
        REV__PCHG_1Y
        NETINC__PCHG_1Y
        EBIT_TTM
        EBIT_TTM__PCHG_1Y
        EBIT_TTM__PCHG_3Y
        SAL_INV
        RETURNS__3650
        RETURNS__2555
        PPE_NET
        OPEX_TTM
        ASSETS_CUR
        LIABS_CUR
        INVY
        INSTPCT
        GWILL
        IMP_GWILL
        DEBT_RAT
        DEPAMOR_TTM
        PROFIT_GROSS_TTM
        PROFIT_OPER_TTM
      }
    }`
  )
  return data
}

